import {
  LOAD_CONTENT_BY_CAT_SLUG,
  LOAD_CONTENT_BY_CAT_SLUG_SUCCESS
} from './constants';

export const initialState = {
  templates: [],
  currentPageOfCategoryPageTemplate: 0,
  totalCategoryPageTemplates: 0,
  numberPagesOfCategoryPage: 0,
  isLoadingCategoryPageTemplates: false,
  hasMoreCategoryPageTemplates: true,
  itemsPerPage: 0,
};

function categoryPageReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_CONTENT_BY_CAT_SLUG:
    return {
      ...state,
      isLoadingCategoryPageTemplates: true,
    };
  case LOAD_CONTENT_BY_CAT_SLUG_SUCCESS:
    return {
      ...state,
      // templates: [...state.templates, ...action.payload.templates],
      templates: action.payload.templates,
      currentPageOfCategoryPageTemplate: action.payload.page,
      totalCategoryPageTemplates: action.payload.total,
      numberPagesOfCategoryPage: action.payload.numberPages > 0
        ? action.payload.numberPages
        : 1,
      isLoadingCategoryPageTemplates: false,
      itemsPerPage: action.payload.itemsPerPage,
    };
  default:
    return state;
  }
}

export default categoryPageReducer;
